module.exports = __webpack_public_path__ + "img/ai-compare-history-calender.86ed5edc.svg";